import Helpers from '../helpers';

/* eslint-disable camelcase */
const Backup = {
	build_table( response ) {
		const $page_main = document.querySelector( '.snapshot-page-main' );
		const $backups = $page_main.querySelector( '.snapshot-listed-backups' );
		const $table = $backups.querySelector( 'table' );

		if ( response.backups !== undefined ) {
			$table.querySelector( 'tbody' ).innerHTML = '';

			const backups = response.backups;
			if ( backups && backups.length ) {
				const $tbody = document.querySelector( 'tbody' );
				backups.forEach( ( backup ) => {
					$tbody.innerHTML += backup.row;
					$tbody.innerHTML += backup.row_content;
				} );

				const trs = $tbody.querySelectorAll( 'tr.snapshot-row' );
				trs.forEach( ( tr ) => {
					tr.classList.add( 'sui-accordion-item' );
					const nextTr = tr.nextElementSibling;
					nextTr.querySelector( '.row-current-schedule' ).querySelector( '.sui-loading' ).style.display = 'none';
					nextTr.querySelector( '.open-edit-schedule' ).style.display = 'block';
					nextTr.querySelector( 'span.schedule' ).textContent = document.querySelector( '.snapshot-schedule-frequency' ).textContent;
					const openEditSchedule = nextTr.querySelector( '.open-edit-schedule' );
					openEditSchedule.onclick = ( e ) => {
						e.preventDefault();
						window.SUI.openModal( 'modal-snapshot-edit-schedule', e.target );
					};
				} );
			}
		}
	},

	reload() {
		const _self = this;

		const $main_page = document.querySelector( '.snapshot-page-main' );

		if ( ! $main_page ) {
			return;
		}

		$main_page.querySelector( '.snapshot-listed-backups' ).style.display = 'none';
		$main_page.querySelector( '.snapshot-backup-list-loader' ).style.display = 'block';

		const fd = new FormData();
		fd.append( '_wpnonce', document.querySelector( '#_wpnonce-list-backups' ).value );
		fd.append( 'action', 'snapshot-list_backups' );
		fd.append( 'force_refresh', '1' );
		fd.append( 'method', 'POST' );

		const request = Helpers.request( fd, 'POST' );
		request
			.then( ( response ) => response.json() )
			.then( ( result ) => {
				$main_page.querySelector( '.snapshot-backup-list-loader' ).style.display = 'none';
				$main_page.querySelector( '.snapshot-listed-backups' ).style.display = 'block';
				_self.build_table( result.data );
			} )
			.catch( ( err ) => {
				console.log( err );
			} );
	},
};

export default Backup;
